module.exports = __webpack_public_path__ + "img/btn_try_me.b9bbf4e9.png";